import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { useLocation } from 'react-router-dom'
import Cookies from 'js-cookie'
import { DOMAINS } from 'src/modules/auth/auth.constants'

const AttendantLogoutButton = ({ tabIndex }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const LOGOUT_PATHNAME = '/collaborators-dashboard'

  const handleLogout = () => {
    const iframe = (document.querySelector('.bwIframe') as HTMLIFrameElement)?.contentWindow
    const platformUrl = process.env.URL_PLATFORM

    Cookies.set('DISPATCH_ATTENDANT_LOGOUT', 'YES', {
      domain: process.env.NODE_ENV === 'production' ? DOMAINS.production : DOMAINS.development
    })

    if (location.pathname === LOGOUT_PATHNAME) {
      if (iframe) {
        iframe.postMessage({ type: 'ATTENDANT.LOGOUT.EXECUTE' }, platformUrl || '')
      }
    } else {
      history.push(LOGOUT_PATHNAME)
    }
  }

  return (
    <div slot="header-actions" className="_mr-3">
      <hot-menu-item data-testid="toggle-item" onClick={handleLogout} tabIndex={tabIndex}>
        <p className="_w-auto _text-2 _m-0">{t('header.menu.attendant.logout')}</p>
      </hot-menu-item>
    </div>
  )
}

export default AttendantLogoutButton
